// UserDetailsModal.jsx
import React from 'react';
import { Modal, Box, Typography, Grid, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useUser } from '../../services/userContext';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 8,
  p: 4,
  maxHeight: '80vh',
  overflowY: 'auto',
};

const sectionHeaderStyle = {
  marginBottom: 2,
  fontWeight: 'bold',
  color: 'text.primary',
};

const detailLabelStyle = {
  fontWeight: '600',
  color: 'text.secondary',
};

const UserDetailsModal = ({ isOpen, onClose }) => {
  const { user } = useUser();

  if (!user.info) {
    return null; // Or a loading state if necessary
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="user-details-title"
      aria-describedby="user-details-description"
    >
      <Box sx={style}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography id="user-details-title" variant="h6" component="h2">
            User Details
          </Typography>
          <IconButton onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Personal Information */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={sectionHeaderStyle}>
            Personal Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2">
                <span style={detailLabelStyle}>First Name:</span> {user.info.firstName}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2">
                <span style={detailLabelStyle}>Last Name:</span> {user.info.lastName}
              </Typography>
            </Grid>
            {/* Add more personal details here if available */}
          </Grid>
        </Box>

        {/* Agency Information */}
        <Box>
          <Typography variant="subtitle1" sx={sectionHeaderStyle}>
            Agency Information
          </Typography>
          <Divider sx={{ mb: 2 }} />
          {user.info.agencyDetails && user.info.agencyDetails.length > 0 ? (
            user.info.agencyDetails.map((agency) => (
              <Box key={agency.agencyId} sx={{ mb: 3, pl: 2 }}>
                <Typography variant="body2">
                  <span style={detailLabelStyle}>Agency Name:</span> {agency.dbaAgencyName}
                </Typography>
                <Typography variant="body2">
                  <span style={detailLabelStyle}>Legal Name:</span> {agency.legalAgencyName}
                </Typography>
                <Typography variant="body2">
                  <span style={detailLabelStyle}>Agency ID:</span> {agency.agencyId}
                </Typography>
                <Typography variant="body2">
                  <span style={detailLabelStyle}>Can Request?:</span> {agency.canRequest ? 'Yes' : 'No'}
                </Typography> <Typography variant="body2">
                  <span style={detailLabelStyle}>Can Post?:</span> {agency.canPost ? 'Yes' : 'No'}
                </Typography>
                {/* Add more agency details here if available */}
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No Agencies Available
            </Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default UserDetailsModal;
